import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewSubAdminPageNews from "../../components/SubAdmin/ViewSubadminPageNew";



const ViewSubadminPage= () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title="View Sub Admin" title2="Sub Admin" link2="/subadmin" />

        {/* AddUserLayer */}
        <ViewSubAdminPageNews />


      </MasterLayout>
    </>
  );
};

export default ViewSubadminPage;
